import React from "react";
import { Grid } from "@mui/material";
import ThreeStackCard from "styles/components/threeStackCard";
import { ImageContainer } from "styles/components/imageContainer";
import theme from "assets/theme";
import { StyledTeamMemberName, StyledTeamMemberTitle, teamMemberImageStyles } from "./index.styles";

const TeamMemberCard = ({ image, name, title }) => {
  const topComponent = () => {
    return <ImageContainer cssProps={teamMemberImageStyles(theme)} image={image} alt={`${name}'s Profile`} />;
  };

  const midComponent = () => {
    return (
      <StyledTeamMemberName component="h3" variant="h5">
        {name}
      </StyledTeamMemberName>
    );
  };

  const botComponent = () => {
    return (
      <StyledTeamMemberTitle component="p" variant="body2">
        {title}
      </StyledTeamMemberTitle>
    );
  };

  return (
    <Grid item xs={12} sm={6} lg={4}>
      <ThreeStackCard
        stackProps={{ justifyContent: "center", alignItems: "center", margin: "auto" }}
        topComponent={topComponent()}
        midComponent={midComponent()}
        botComponent={botComponent()}
      />
    </Grid>
  );
};

export default TeamMemberCard;
